/**
 * Digital Rips "Add to Cart with promo code DIGRIP15".
 *
 * A discount code can only be attached to a session by visiting
 * /discount/<code>, which the theme's AJAX cart drawer never does. So on the
 * Digital Rips product pages we take over the click, add the item ourselves,
 * and then hand the browser to the discount route, which applies DIGRIP15 and
 * redirects to the cart. The shopper lands on a cart that already shows 15%
 * off, instead of a drawer at full price with a code they have to type.
 *
 * Bound once, delegated from the document, and scoped to buttons carrying
 * data-digrip-add (set in snippets/buy-buttons.liquid).
 */
(function () {
  if (window.__digripPromoAtcBound) return;
  window.__digripPromoAtcBound = true;

  var DISCOUNT_URL = '/discount/DIGRIP15?redirect=/cart';

  document.addEventListener(
    'click',
    function (event) {
      var target = event.target;
      if (!target || typeof target.closest !== 'function') return;

      var button = target.closest('[data-digrip-add]');
      if (!button || button.disabled || button.getAttribute('aria-disabled') === 'true') return;

      var form = button.form || button.closest('form');
      if (!form) return;

      // Cancel the submit before product-form.js can turn it into a drawer add.
      event.preventDefault();
      event.stopImmediatePropagation();

      button.setAttribute('aria-disabled', 'true');
      button.classList.add('loading');
      var spinner = button.querySelector('.loading__spinner');
      if (spinner) spinner.classList.remove('hidden');

      var addUrl = (window.routes && window.routes.cart_add_url) || '/cart/add';
      fetch(addUrl + '.js', {
        method: 'POST',
        body: new FormData(form),
        credentials: 'same-origin',
        headers: { Accept: 'application/json' }
      })
        .then(function (response) {
          if (!response.ok) throw new Error('cart/add.js returned ' + response.status);
          window.location.href = DISCOUNT_URL;
        })
        .catch(function () {
          // Let the browser post the form the old-fashioned way. Calling
          // submit() directly skips the AJAX submit listener, so the form's
          // return_to carries the shopper through the same discount route.
          form.submit();
        });
    },
    true
  );
})();
